import { CommunityManager } from "@/pages/save/CommunityManager";

// Save · Community (contacts). Master-detail community management; the "Alle"
// entry in its list covers the full contact list, so there is no separate grid.
export function ContactPage() {
  return <CommunityManager />;
}
